import React, { VoidFunctionComponent } from "react";
import { DisplayStars } from '@/components/responsive/product/seller/DisplayStars';
import { Review } from "@/models/scope/productSheet/reviews/Review";

export const ReviewBlock: VoidFunctionComponent<{ review: Review }> = ({ review }) => {
    const { title, rate, content, pseudo, submissionDate, orderDate } = review;

    const renderHeader = (): JSX.Element => {
        return (
            <div className='header'>
                <p className='title'>{title}</p>
                <div className='rate'>
                    <p>{rate}/5</p>
                    <div className='rating-stars'>
                        <DisplayStars score={rate} />
                    </div>
                </div>
            </div>
        );
    };

    const renderContent = (): JSX.Element  => {
        return (
            <div className='content'>
                <p>{content}</p>
            </div>
        );
    };

    const renderReviewBottom = (): JSX.Element  => {
        return (
            <div className='review-bottom'>
                <p>
                    <span>{pseudo}.</span> {submissionDate} Suite à une commande le{' '}
                    {orderDate}
                </p>
            </div>
        );
    };
    return (
        <div className='review-block'>
            {renderHeader()}
            {renderContent()}
            {renderReviewBottom()}
        </div>
    );
};